export default __webpack_public_path__ + "static/media/BannerCS-10May(768x800).af59242c.webp";